<template>
    <div class="wrapper wrapper-content" :class="showWrapper ? 'show' : 'hide'">
        <div class="ibox-content c2d_cont_1">
          <div class="collapse" :id="'collapse_'+id">
            <div class="card card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="panel panel-info">
                    <div class="panel-heading">
                      Customer Feedback Trend
                    </div>
                    <div class="panel-body">
                      <Loader class="d_flex" v-if="loadQRStats" />
                      <LineChart v-else :data="feedbackSeries" color="#79dfc1" :title="'Customer Feedback Trend'" :categories="feedbackCategories" side-text="Number of Feedbacks" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="panel panel-success">
                    <div class="panel-heading">
                      Scans Over Time
                    </div>
                    <div class="panel-body">
                      <Loader :class="loadScanOverTime ? 'd_flex' : 'hide'"/>
                      <LineChart :class="loadScanOverTime ? 'hide' : 'show'" :data="scansOverTimeSeries" color="#70A6F9" :title="'Scans Over Time'" :categories="scansOverTimeCategories" side-text="Number of Scans" :filters="scansOverTimeFilters" @input="handleFilterChange" :default-filter="defaultFilter"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="col-md-4">
                  <div class="panel panel-warning">
                    <div class="panel-heading">
                      Scans By Operating System
                    </div>
                    <div class="panel-body">
                      <Loader class="d_flex" v-if="loadQRStats" />
                      <BarChart v-else :data="scansByOperatingSystemSeries" :title="'Scans By Operating System'" color="#FEB272" :categories="scansByOperatingSystemCategories" side-text="Number of Scans" :height=500 />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="panel panel-danger">
                    <div class="panel-heading">
                      Scans By Cities
                    </div>
                    <div class="panel-body">
                      <Loader class="d_flex" v-if="loadQRStats" />
                      <BarChart v-else :data="scansByCitiesSeries" :title="'Scans By Cities'" color="#EB868F" :categories="scansByCitiesCategories" bottom-text="Number of Scans" side-text="Number of Scans" :height=500 />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="panel panel-primary">
                    <div class="panel-heading">
                      Scans By Countries
                    </div>
                    <div class="panel-body">
                      <Loader class="d_flex" v-if="loadQRStats" />
                      <BarChart v-else :data="scansByCountriesSeries" :title="'Scans By Countries'" color="#A98EDA" :categories="scansByCountriesCategories" bottom-text="Number of Scans" side-text="Number of Scans" :height=500 />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import LineChart from "@/components/charts/LineChart.vue";
import BarChart from "@/components/charts/BarChart.vue";
import { getScansOverTimeAnalytics} from "@/api/FirestoreRestaurant";
import Loader from "@/components/utils/Loader.vue";

export default {
  name: "QRAnalyticsGraphs",

  components: {Loader, LineChart, BarChart},

  data () {
    return {
      scansByOperatingSystemSeries: [],
      scansByOperatingSystemCategories: [],
      scansByCitiesSeries: [],
      scansByCitiesCategories: [],
      scansByCountriesSeries: [],
      scansByCountriesCategories: [],
      scansOverTimeSeries: [],
      scansOverTimeCategories: [],
      feedbackSeries: [],
      feedbackCategories: [],
      scansOverTimeFilters: ['days', 'months'],
      defaultFilter: false,
      loadScanOverTime: false,
      showWrapper: true
    }
  },

  computed: {
    selectedGraph() {
      return this.$store.state.collapseId
    }
  },

  props: {
        branchStats: {
            type: Object,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
      restaurantId: {
            type: Number,
            required: false,
        },
      restaurantName: {
            type: String,
            required: false,
        },
     loadQRStats: {
            type: Boolean,
            required: true,
        },
    },

  watch: {
    branchStats: {
      handler(val) {
        if (val.scansByOperatingSystem && val.scansByOperatingSystem.x_axis) {
          this.scansByOperatingSystemCategories = val.scansByOperatingSystem.x_axis.map(item =>
              item === 'linux' ? 'android' : item
          );
        }
        this.scansByCitiesCategories = val.scansByCities && val.scansByCities.x_axis;
        this.scansByCountriesCategories = val.scansByCountries && val.scansByCountries.x_axis;
        this.scansOverTimeCategories = val.scansOverTimeStats && val.scansOverTimeStats.x_axis;
        this.feedbackCategories = val.customerFeedbackTrend && val.customerFeedbackTrend.x_axis;
        this.createFeedbackSeries(val.customerFeedbackTrend);
        this.createSeries(
            this.scansByOperatingSystemSeries,
            this.scansByOperatingSystemCategories,
            val.scansByOperatingSystem.totalScan,
            val.scansByOperatingSystem.uniqueScan,
            '#FEB272',
            '#EB868F'
        );
        this.createSeries(
            this.scansByCitiesSeries,
            this.scansByCitiesCategories,
            val.scansByCities.totalScan,
            val.scansByCities.uniqueScan,
            '#EB868F',
            '#A98EDA'
        );
        this.createSeries(
            this.scansByCountriesSeries,
            this.scansByCountriesCategories,
            val.scansByCountries.totalScan,
            val.scansByCountries.uniqueScan,
            '#A98EDA',
            '#FEB272'
        );
        this.createSeries(
            this.scansOverTimeSeries,
            this.scansOverTimeCategories,
            val.scansOverTimeStats.totalScan,
            val.scansOverTimeStats.uniqueScan,
            '#79dfc1',
            '#70A6F9'
        );
        this.defaultFilter = true;
      },
      immediate: true,
      deep: true
    },

    loadQRStats: {
      handler(val) {
        this.loadScanOverTime = val
      }
    },

    selectedGraph: {
      handler(val) {
        this.showWrapper = val === this.id
      },
      immediate: true
    }
  },

  methods: {
    createSeries(series, categories, totalScan, uniqueScan, colorOfFirstBar, colorOfSecondBar) {
      series.splice(0); // Clear the existing series array
      if (totalScan) {
        series.push(
            {
              name: 'total scan',
              color: colorOfFirstBar,
              data: totalScan
            },
            {
              name: 'unique scan',
              color: colorOfSecondBar,
              data: uniqueScan
            }
        );
      }
    },

    createFeedbackSeries(customerFeedbackTrend) {
      this.feedbackSeries.splice(0); // Clear the existing series array
      if (customerFeedbackTrend) {
        this.feedbackSeries.push(
            {
              name: 'Awesome',
              color: '#33ADF9',
              data: customerFeedbackTrend.awesome
            },
            {
              name: 'dissatisfied',
              color: '#5863C6',
              data: customerFeedbackTrend.dissatisfied
            },
            {
              name: 'neutral',
              color: '#6DE373',
              data: customerFeedbackTrend.neutral
            },
            {
              name: 'satisfied',
              color: '#F46A39',
              data: customerFeedbackTrend.satisfied
            },
        );
      }
    },

    handleFilterChange(selectedFilter) {
      this.updateScanOverTimeStats(selectedFilter)
    },

    async updateScanOverTimeStats(selectedFilter) {
      this.loadScanOverTime = true
      let params = new URLSearchParams();
      params.append("restaurant_id", this.restaurantId);
      params.append("branch_id", this.branchStats.branchId);
      params.append("restaurant_name", this.restaurantName);
      params.append("year", new Date().getFullYear());
      params.append("month", new Date().getMonth() + 1);
      params.append("find_by", selectedFilter);
      const {data} = await getScansOverTimeAnalytics(params)
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      const {body} = data
      this.scansOverTimeCategories = body.x_axis && body.x_axis
      this.createSeries(this.scansOverTimeSeries, this.scansOverTimeCategories, body.totalScan, body.uniqueScan, '#79dfc1', '#70A6F9')
      this.defaultFilter = false
      this.loadScanOverTime = false
    }
  }
}
</script>

<style scoped>
.d_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hide {
  display: block;
}

.show {
  display: none;
}
</style>